<template>
  <div class="mainContent" :class="isPcNew?'canShowPc':''">
    <div class="home-box flex flex-d ai-c">
      <img src="@/assets/extensionNew/newbgTwo.jpg" alt="">
      <div class="goOut" @click="goDetails">【详细了解弦镜】</div>
      <div class="btn flex ai-c jc-c" @click="showModel">具体操作步骤>></div>
      <div class="downbtnOne" @click="goDownLoad">下载弦镜app</div>
      <div class="goDown" @click="goDownLoad">"弦镜"APP下载</div>
      <div class="goDown officialAccount">"星图数据"公众号</div>
      <Popup v-model="canshow">
        <div class="showRecord flex flex-d jc-sb ai-c">
          <div class="downbtn" @click="goDownLoad">下载弦镜app</div>
        </div>
      </Popup>
      <Overlay :show="show" @click="show = false">
        <div class="wrapper">
          <img class="logo" src="@/assets/goDown.png">
        </div>
        <div class="goDownTitle">1.点击右上角"..."</div>
        <div class="goDownTitle">2.选择"在浏览器中打开"</div>
      </Overlay>
    </div>
  </div>
</template>

<script>
import { Popup } from 'vant';
import { Overlay } from 'vant';
export default {
  name: 'carrousel',
  data() {
    return {
      isPcNew: false,
      canshow: false,//弹窗
      show: false,//提示下载弹窗
    }
  },
  components: {
    Popup,
    Overlay,
  },
  created() {
    if(document.body.clientWidth>1100){
      this.isPcNew=true;
    }
  },
  mounted () {
    document.querySelector('meta[name="keywords"]').setAttribute('content',"弦镜推广大使活动");
    document.querySelector('meta[name="description"]').setAttribute('content',"弦镜推广大使活动");
  },
  computed: {},
  methods: {
    //跳转页面
    goDetails(){
      window.open("http://msstatic.synlen.com/#/animation");
    },
    // 显示弹框
    showModel() {
      this.canshow = true;
    },
    //去下载
    goDownLoad(){
      var u = navigator.userAgent;
      var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      var isAndroid= u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      //u.toLowerCase().match(/MicroMessenger/i) == "micromessenger" //微信自带的浏览器打开
      if(isIos){
        //ios
        // console.log('ios浏览器')
        if(u.toLowerCase().match(/MicroMessenger/i) == "micromessenger"){
          //微信自带的浏览器打开
          this.canshow=false;
          this.show=true;
          // window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.syntun.synlen';
        }else{
          window.location.href = 'https://apps.apple.com/cn/app/id1601918648';
        }
      }else if(isAndroid){
        //安卓
        // console.log('安卓浏览器')
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.syntun.synlen';
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/styles/common.scss";
.home-box {
  overflow-x: hidden;
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
  .goOut{
    color: #5ac4fd;
    position: absolute;
    top: 749px;
    left: 230px;
    font-size: 26px;
    cursor: pointer;
  }
  .btn {
    width: 250px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    background-color: #273866;
    border-radius: 40px;
    color: #fff;
    font-size: 22px;
    position: absolute;
    top: 1790px;
    left: 50%;
    margin-left: -125px;
    cursor: pointer;
    font-family: 'Source Han Sans CN';
    font-weight: 400;
  }
  .downbtnOne{
    color: #5ac4fd;
    position: absolute;
    top: 1673px;
    left: 170px;
    font-size: 26px;
    font-weight: 600;
    cursor: pointer;
    border-bottom: 1px solid #5ac4fd;
  }
  .goDown{
    color: #03DFD1;
    position: absolute;
    top: 3395px;
    left: 216px;
    font-size: 16px;
    cursor: pointer;
    border-bottom: 1px solid #03DFD1;
  }
  .officialAccount{
    left: 410px;
  }
}
.van-popup--center{
  background: none;
  margin-top: -30px;
}
.showRecord{
  width: 600px;
  height: 1100px;
  background: url("~@/assets/extensionNew/modelbg.png") no-repeat;
  background-size: 100% 100%;
  margin: 0 auto;
  padding: 190px 0 30px;
  box-sizing: border-box;
  position: relative;
  .downbtn{
    // width: 200px;
    // height: 50px;
    color: #5ac4fd;
    position: absolute;
    top: 172px;
    left: 135px;
    font-size: 26px;
    font-weight: 600;
    cursor: pointer;
    border-bottom: 1px solid #5ac4fd;
  }
}
//下载
.wrapper{
  text-align: right;
  padding: 0 10px;
  .logo{
    width: 250px;
    margin: 40px;
  }
}
.goDownTitle{
  width: 100%;
  text-align: left;
  color: #fff;
  font-size: 60px;
  padding: 0 30px;
}
/deep/ .van-overlay{
  background-color: rgba(0,0,0,.8);
}
//适配pc，大于1100px
// @media screen and (min-device-width:1100px){
//   .canShowPc{
//     // background-color: #40062e;
//     .home-box{
//       width: 375px;
//       margin: 0 auto;
//       position: relative;
//       .goOut{
//         top: 375px;
//         left: 110px;
//         font-size: 12px;
//       }
//       .btn{
//         width: 120px;
//         height: 25px;
//         line-height: 25px;
//         border-radius: 15px;
//         font-size: 12px;
//         top: 895px;
//         left: 50%;
//         margin-left: -60px;
//       }
//       .downbtnOne{
//         top: 838px;
//         left: 86px;
//         font-size: 12px;
//         border-bottom: 1px solid #5ac4fd;
//       }
//       .goDown{
//         top: 1700px;
//         left: 102px;
//         font-size: 10px;
//         border-bottom: 1px solid #03DFD1;
//       }
//       .officialAccount{
//         left: 198px;
//       }
//     }
//     .showRecord{
//       width: 210px;
//       height: 350px;
//       padding: 0;
//       .downbtn{
//         top: 54px;
//         left: 50px;
//         font-size: 8px;
//         font-weight: 600;
//         border-bottom: 1px solid #5ac4fd;
//       }
//     }
//     .van-popup--center{
//       margin-top: 0px;
//     }
//   }
// }
</style>